import { locales } from './locales'
import { repositories } from './repositories'
import { routes } from './routes'
import { services } from './services'
import { stores } from './stores'

export * from './types'
export * from './constants'
export { GaCoinButton } from './components/molecules/coin-button'
export { GaDailyRewardModal } from './components/organisms/daily-reward-modal'
export { GaPrizeModal } from './components/template/prizes/children/modal'
export { GaPromoModal } from './components/organisms/promo-modal'
export { GaOnboardingModal } from './components/organisms/onboarding-modal'
export { GaLanguageSwitcher } from './components/organisms/language-switcher'
export { GaRatingPreviousModal } from './components/template/rating/children/previous-modal'
export { GaRatingResultsModal } from './components/organisms/rating-results-modal'
export { GaReward } from './components/molecules/reward'
export { GaPrizeImage } from './components/molecules/prize-image'
export { useUser } from '~/modules/main/composables/user'
export {
  getRatingPlaceImageSrc,
  mapLeaderboardPeriodsToRatingPeriods,
  mapLeaderboardTopToRatingEntries,
  resolveProfileAvatar,
  mapUserPositionsResponse,
} from './utils'

export const main: {
  meta: {
    name: 'main'
    locales: typeof locales
    routes: typeof routes
  }
  layers: {
    stores: typeof stores
    services: typeof services
    repositories: typeof repositories
  }
} = {
  meta: {
    name: 'main',
    locales,
    routes,
  },
  layers: {
    stores,
    services,
    repositories,
  },
}
